/* Header section module — mega-menu stagger opt-in + mobile drill navigation.
   Hover-intent, keyboard, focus-out and the solidify observer all live in
   global.js (<pf-menu>, <pf-header>). Custom elements re-init on section load. */

const STAGGER = window.PLANTFORM?.staggerMenu ?? true;

class PFMobileNav extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const toggle = e.target.closest('.mobile-nav__toggle');
      if (toggle && this.contains(toggle)) this._set(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });

    // collapse every group whenever the drawer closes
    this.closest('pf-drawer')?.addEventListener('drawer:close', () => {
      this.querySelectorAll('.mobile-nav__toggle[aria-expanded="true"]').forEach((t) => this._set(t, false));
    });
  }

  _set(toggle, open) {
    toggle.setAttribute('aria-expanded', String(open));
    document.getElementById(toggle.getAttribute('aria-controls'))?.classList.toggle('is-open', open);
  }
}
customElements.define('pf-mobile-nav', PFMobileNav);

function applyStagger(root = document) {
  if (!STAGGER) return;
  root.querySelectorAll('.header .mega, .header .mega--simple').forEach((m) => m.setAttribute('data-stagger', ''));
}
applyStagger();
document.addEventListener('shopify:section:load', (e) => applyStagger(e.target));
